import { TCommissionHistoryQuery } from '../helpers';
import { IGetCommissionHistoryListDTO } from '@/models/commission.model';

class GetCommissionHistoryListDTO implements IGetCommissionHistoryListDTO {
  date_from?: string;
  date_to?: string;
  category_id?: string;
  changed_by_admin_id?: string;
  page?: number;

  constructor({ date_from, date_to, category_id, changed_by_admin_id, page }: TCommissionHistoryQuery) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.category_id = category_id;
    this.changed_by_admin_id = changed_by_admin_id;
    this.page = page;
  }
}

export default GetCommissionHistoryListDTO;
